module.exports = __webpack_public_path__ + "static/media/erdbselect.13b6a733.svg";